import { Component } from '@verndale/core';
import 'slick-carousel';

class FeaturedBlogNews extends Component {
  setupDefaults() {
    this.dom = {
      list: this.el.querySelector('.featured-blog-news__list'),
      viewMoreCta: this.el.querySelector('.featured-blog-news__view-more')
    };
    this.setupViewMoreCta();
    this.setupSlider()
  }

  addListeners() {
    this.dom.viewMoreCta.addEventListener('click', ::this.handleShowMoreClick)
    window.addEventListener('resize', ::this.handleWindowResize)
  }

  handleShowMoreClick() {
    if (this.el.classList.contains('open')) {
      this.el.classList.remove('open')
      window.scrollTo({
        top: this.el.offsetTop,
        left: 0,
        behavior: 'smooth'
      });
    } else {
      this.el.classList.add('open')
    }

  }

  handleWindowResize() {
    if (window.innerWidth < 768 && !this.dom.list.classList.contains('slick-initialized')) {
      this.setupSlider();
    }
  }

  setupViewMoreCta() {
    if (this.dom.list.children.length > 3) {
      this.dom.viewMoreCta.classList.add('active');
    }
  }

  setupSlider() {
    $(this.dom.list).slick({
      dots: true,
      arrows: false,
      mobileFirst: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 767,
          settings: 'unslick'
        }
      ]
    });
  }
}

export default FeaturedBlogNews;
